import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/authservice/auth.service';

@Component({
  selector: 'app-institution',
  templateUrl: './institution.component.html',
  styleUrls: ['./institution.component.scss'],
  standalone: false
})
export class InstitutionComponent implements OnInit {
  isModalVisible = false;
  selectedRole = '';  // e.g., 'teacher', 'student', etc.
  userEmail = '';
  userData: any;
  subscription: any;
  constructor( public translate: TranslateService,private authService:AuthService) { }

  ngOnInit(): void {

    this.subscription = this.authService.currentUser$.subscribe(user => {
      this.userData = user;
    });
  }
 // Call this when a role is selected to open the modal
 openRoleModal(role: string): void {
  this.selectedRole = role;
  this.isModalVisible = true;
}
handleModalClose(): void {
  this.isModalVisible = false;
}
handleModalContinue(email: string): void {
  // Use the provided email and role to navigate or process further

  this.isModalVisible = false;
  // For example, navigate to the next step of the sign-up flow
}
}
